var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashDelete = function SvgTrashDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B80303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M26.25 7.475c-4.163-.412-8.35-.625-12.525-.625q-3.713 0-7.425.375l-2.55.25M10.625 6.213l.275-1.638c.2-1.187.35-2.075 2.463-2.075h3.274c2.113 0 2.276.938 2.463 2.088l.275 1.625M23.563 11.425l-.813 12.587c-.137 1.963-.25 3.488-3.738 3.488h-8.024c-3.488 0-3.6-1.525-3.738-3.488l-.812-12.587M12.912 20.625h4.163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B80303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.875 15.625h6.25"
  })));
};
export default SvgTrashDelete;